import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { ChevronIcon } from "../icons";
import S from "../styles";

export default function Dropdown({ label, value, onChange, options, placeholder, disabled }) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const dropRef = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (btnRef.current && btnRef.current.contains(e.target)) return;
      if (dropRef.current && dropRef.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const handleOpen = () => {
    if (btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 2, left: rect.left, width: rect.width });
    }
    setOpen(!open);
  };

  const selectedLabel = options.find((o) => o.value === value)?.label || "";

  return (
    <div style={{ marginBottom: 14, opacity: disabled ? 0.45 : 1, pointerEvents: disabled ? "none" : "auto" }}>
      {label && <label style={S.label}>{label}</label>}
      <div>
        <button
          ref={btnRef}
          type="button"
          onClick={handleOpen}
          style={{ ...S.selectBtn, borderColor: open ? "#0033FF" : "#0A0A0F" }}
        >
          <span style={{ color: value ? "#0A0A0F" : "rgba(10,10,15,0.58)" }}>{selectedLabel || placeholder}</span>
          <ChevronIcon open={open} />
        </button>
        {open && ReactDOM.createPortal(
          <div
            ref={dropRef}
            style={{
              position: "fixed",
              top: pos.top,
              left: pos.left,
              width: pos.width,
              background: "#FFFFFF",
              border: "2px solid #0A0A0F",
              borderRadius: 0,
              zIndex: 9999,
              maxHeight: 200,
              overflowY: "auto",
              boxShadow: "0 12px 32px rgba(0,0,0,.4)",
            }}
          >
            {options.map((opt) => (
              <div
                key={opt.value}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                style={{
                  ...S.dropdownItem,
                  background: opt.value === value ? "#F4F2EC" : "transparent",
                  color: opt.value === value ? "#0033FF" : "#0A0A0F",
                }}
                onMouseEnter={(e) => { if (opt.value !== value) e.currentTarget.style.background = "rgba(22,45,80,0.5)"; }}
                onMouseLeave={(e) => { if (opt.value !== value) e.currentTarget.style.background = "transparent"; }}
              >
                {opt.label}
              </div>
            ))}
            {options.length === 0 && (
              <div style={{ ...S.dropdownItem, color: "rgba(10,10,15,0.58)" }}>No options</div>
            )}
          </div>,
          document.body
        )}
      </div>
    </div>
  );
}
